import notification from '@/ApiConstance/toast'
import { api } from '../index'

export default {
  async createMeeting(payload) {
    return await api.post('/storemeet', payload).then(() => {
      notification.toast('SuccessFully Created a Meeting', 'success')
    })
  },
  async allMeetings() {
    return await api.get('/getallmeetings')
  },

  async updateMeeting(payload, id) {
    return await api.put(`/updatemeeting/${id}`, payload).then(() => {
      window.location.href = '/meetings'
    })
  },

  async deleteMeeting(id) {
    return await api.delete(`/deletemeeting/${id}`).then(() => {
      window.location.href = '/meetings'
    })
  },
}
